<div *ngIf="dataSource?.length" class="hidden-custom">
  <h2 class="text-2xl font-bold">لیست اقامتگاه‌های بومگردی ایران</h2>
  <div class="bg-grey-50 rounded-2xl">
    <div class="flex items-center p-4 !pb-1 overflow-x-scroll mt-7 statesList w-[98%] cursor-move">
      <span *ngFor="let state of dataSource; let index = index"
        class="px-4 inline-block relative text-base whitespace-nowrap border-b border-solid border-black-100 pb-3"
        [ngClass]="{
                'font-bold border-b-2 border-blue-500': index === activeIndex
              }" (click)="activeIndex = index">
        {{state?.Title}}
        <span *ngFor="let city of state.Cities" class="h-0 overflow-hidden w-0 invisible inline-block opacity-0">
          {{city?.Title}}
        </span>

      </span>
    </div>
    <!-- <div class="h-[1px] bg-black-100 mx-4"></div> -->
    <div class="grid grid-cols-5 grid-rows-4 overflow-x-auto bg-grey-50 px-4 pb-2">
      <div *ngFor="let city of dataSource[activeIndex].Cities" class="py-2 text-sm">
        <a [href]="city.Url">
          {{city?.Title}}
        </a>
      </div>
    </div>
  </div>
</div>